// extracted by mini-css-extract-plugin
module.exports = {"headerDesktop":"Footer_headerDesktop__27gD9","icon":"Footer_icon__ISVxC"};